// @mui
import Skeleton from '@mui/material/Skeleton';

export function ReportTableSkeleton() {
  return <Skeleton variant="rounded" height={600} />;
}
